import { Divider } from '@material-ui/core';
import { BooleanField, Datagrid, DateField, List, Show, TabbedShowLayout, TextField, WithRecord } from 'react-admin';

export const QuoteRequestList = () => (
    <List>
        <Datagrid rowClick="show"
            sort={{ field: 'createdAt', order: 'DESC'}}
            isRowSelectable={(record) => false}
        >
            <TextField source="id" />
            <TextField source="enquireName" />
            <TextField source="enquireEmail" />
            <TextField source="enquirePhone" />
            <TextField source="enquireAddress" />
            <TextField source="enquireMessage" />
            <TextField source="totalEstimate" />
            <TextField source="totalAppliance" />
            <TextField source="totalMaterial" />
            <TextField source="totalWork" />
            <BooleanField source="emailSent" />
            <DateField source="createdAt" />
            { /*
			<TextField source="addonApplianceText" />
			<TextField source="addonApplianceValue" />
			<TextField source="addonBenchtopsText" />
			<TextField source="addonBenchtopsValue" />
			<TextField source="addonDoorsText" />
			<TextField source="addonDoorsValue" />
			<TextField source="addonHardwareText" />
			<TextField source="addonHardwareValue" />
			<TextField source="addonTradeworksText" />
			<TextField source="addonTradeworksValue" />
			<TextField source="applianceBrand" />
			<TextField source="applianceCooktop" />
			<TextField source="applianceCooktopType" />
			<TextField source="applianceDishwasher" />
			<TextField source="applianceFridge" />
			<TextField source="applianceOven" />
			<TextField source="applianceRangehood" />
			<TextField source="applianceSink" />
			<BooleanField source="buildingCarpentry" />
			<BooleanField source="buildingDemolition" />
			<BooleanField source="buildingElectrical" />
			<BooleanField source="buildingFlooring" />
			<BooleanField source="buildingInstallation" />
			<BooleanField source="buildingLighting" />
			<BooleanField source="buildingPlastering" />
			<BooleanField source="buildingPlumbing" />
			<BooleanField source="buildingRubbishRemoval" />
			<BooleanField source="buildingTiling" />
			<TextField source="dimensionA" />
			<TextField source="dimensionB" />
			<TextField source="dimensionC" />
			<TextField source="dimensionD" />
			<BooleanField source="emailSent" />
			<BooleanField source="enquireSendEmail" />
			<TextField source="enquireZipcode" />
			<TextField source="finishBenchtops" />
			<TextField source="finishDoors" />
			<TextField source="finishHardware" />
			<TextField source="ipAddr" />
			<TextField source="json" />
			<TextField source="shape" />

			<TextField source="uuid" />
*/ }
        </Datagrid>
    </List>
)


export const QuoteRequestShow = () => (
    <Show>
        <WithRecord
            render={record => {
                const emailJson = record.json ? JSON.parse(record.json) : null
                // console.log(record, Object.keys(json))
                if (emailJson) {
                    record.headers = emailJson.headers
                    record.message = emailJson.message
                }
                return (
                    <TabbedShowLayout>
                        <TabbedShowLayout.Tab label='Enquiry'>
                            <TextField source="enquireName" />
                            <TextField source="enquireEmail" />
                            <TextField source="enquirePhone" />
                            <TextField source="enquireAddress" />
                            <TextField source="enquireMessage" />
                            <TextField source="enquireZipcode" />
                            <BooleanField source="enquireSendEmail" />
                            <BooleanField source="emailSent" />
                        </TabbedShowLayout.Tab>

                        <TabbedShowLayout.Tab label='Selection'>
                            <TextField source="finishBenchtops" />
                            <TextField source="finishDoors" />
                            <TextField source="finishHardware" />
                            <TextField source="shape" />
                        </TabbedShowLayout.Tab>

                        <TabbedShowLayout.Tab label='Dimensions'>
                            {/*
                            <TextField source="dimensionA" />
                            <TextField source="dimensionB" />
                            <TextField source="dimensionC" />
                            <TextField source="dimensionD" />
                            */}
                            <TextField source="totalBase" />
                            <TextField source="totalWall" />
                            <TextField source="totalTall" />
                        </TabbedShowLayout.Tab>

                        <TabbedShowLayout.Tab label='Totals'>
                            <TextField source="totalAppliance" width={80} style={{ textAlign: 'right' }} />
                            <TextField source="totalMaterial" width={80} style={{ textAlign: 'right' }} />
                            <TextField source="totalWork" width={80} style={{ textAlign: 'right' }} />
                            <TextField source="totalEstimate" width={80} style={{ textAlign: 'right' }} />
                        </TabbedShowLayout.Tab>

                        <TabbedShowLayout.Tab label='Appliances'>
                            <TextField source="applianceBrand" />
                            <TextField source="applianceCooktopType" />
                            <TextField source="applianceCooktop" />
                            <TextField source="applianceDishwasher" />
                            <TextField source="applianceFridge" />
                            <TextField source="applianceOven" />
                            <TextField source="applianceRangehood" />
                            <TextField source="applianceSink" />
                        </TabbedShowLayout.Tab>

                        <TabbedShowLayout.Tab label='Addons'>
                            <TextField source="addonApplianceText" />
                            <TextField source="addonApplianceValue" />
                            <Divider />
                            <TextField source="addonBenchtopsText" />
                            <TextField source="addonBenchtopsValue" />
                            <Divider />
                            <TextField source="addonDoorsText" />
                            <TextField source="addonDoorsValue" />
                            <Divider />
                            <TextField source="addonHardwareText" />
                            <TextField source="addonHardwareValue" />
                            <Divider />
                            <TextField source="addonTradeworksText" />
                            <TextField source="addonTradeworksValue" />
                        </TabbedShowLayout.Tab>

                        <TabbedShowLayout.Tab label='Trade Works'>
                            <BooleanField source="buildingCarpentry" />
                            <BooleanField source="buildingDemolition" />
                            <BooleanField source="buildingElectrical" />
                            <BooleanField source="buildingFlooring" />
                            <BooleanField source="buildingInstallation" />
                            <BooleanField source="buildingLighting" />
                            <BooleanField source="buildingPlastering" />
                            <BooleanField source="buildingPlumbing" />
                            <BooleanField source="buildingRubbishRemoval" />
                            <BooleanField source="buildingTiling" />
                        </TabbedShowLayout.Tab>

                        <TabbedShowLayout.Tab label='Misc'>
                            <TextField source="id" />
                            <TextField source="ipAddr" />
                            {/* <TextField source="json" /> */}
                            <TextField source="uuid" />
                            {record.headers ? <>
                                <strong>Headers</strong>
                                <textarea readOnly
                                    value={record.headers}
                                />
                            </> : null}
                            {record.message ? <>
                                <strong>Email Content</strong>
                                <iframe srcDoc={record.message} title="preview"
                                    width="100%"
                                    height={500}
                                />
                            </> : <small>no email sent</small>}
                        </TabbedShowLayout.Tab>
                    </TabbedShowLayout>
                )
            }} />

    </Show>
)